<template>
  <div class="view box grow">
    <page-headers
        :header="'Insights'"
        :breadcrumbs="breadcrumbs"
        :is-border="true"
        documentation="page-insights"
        class="box"
    >
      <div slot="actions" class="float-right">
        <date-range-dropdown
            :date-range-options="dateRangeOptions"
            :disable-selection="isStatsLoading"
            :store-pref-constant="daterangeUserPrefConstant"
            :date-range-val="insightsDateRangeUserSetting"
        ></date-range-dropdown>
      </div>
    </page-headers>
    <el-row class="insights-content box grow" :gutter="0">
      <el-col :span="4">
        <el-menu :default-active="selectedInsight" @select="changeInsightView" :default-openeds="['windows', 'linux']">
          <el-submenu v-if="['hybrid', 'windows'].indexOf(agentEnvironment) >= 0" index="windows">
            <template slot="title">Windows</template>
            <el-menu-item
                class="subtitle2"
                v-for="insightName in windowsInsightsList"
                :key="insightName.name"
                :index="insightName.name"
                :class="{ 'is-active': routePath === insightName.name }"
            >
              {{ insightName.label }}
            </el-menu-item>
          </el-submenu>
          <el-submenu v-if="['hybrid', 'linux'].indexOf(agentEnvironment) >= 0" index="linux">
            <template slot="title">Linux</template>
            <el-menu-item
                class="subtitle2"
                v-for="insightName in linuxInsightsList"
                :key="insightName.name"
                :index="insightName.name"
                :class="{ 'is-active': routePath === insightName.name }"
            >
              {{ insightName.label }}
            </el-menu-item>
          </el-submenu>
        </el-menu>
      </el-col>
      <el-col :span="20" class="el-tabs__content">
        <router-view :key="$route.path"/>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import {mapGetters} from 'vuex'

import PageHeaders from '@/components/layout/PageHeaders.vue'
import DateRangeDropdown from '@/components/dropdown/DateRangeDropdown.vue'
import {INSIGHTS_DATE_RANGE_CHOICES} from '@/constants/datetime.constants'
import {INSIGHTS_DATE_RANGE_PREFERENCE} from '@/store/modules/user_pref/user-pref.type'

export default {
  name: 'Insights',
  data() {
    return {
      selDate: {},
      routePath: '/insights/windows-dns-requests',
      daterangeUserPrefConstant: INSIGHTS_DATE_RANGE_PREFERENCE,
      dateRangeOptions: INSIGHTS_DATE_RANGE_CHOICES,
      breadcrumbs: [{title: 'Analytics'}, {title: 'Insights'}],
      selectedInsight: 'windows-dns-requests',
      windowsInsightsList: [
        {label: 'Login Failures', name: 'windows-logon-failures'},
        {label: 'External Connections', name: 'windows-external-connections'},
        {label: 'Privileged Executions', name: 'windows-privileged-executions'},
        {label: 'DNS Requests', name: 'windows-dns-requests'}
      ],
      linuxInsightsList: [
        {label: 'Login Failures', name: 'linux-login-failures'},
        {label: 'External Connections', name: 'linux-external-connections'},
        {label: 'Privileged Executions', name: 'linux-privileged-executions'},
        {label: 'Process Launching Shells', name: 'linux-process-launching-shells'},
        {label: 'Sensitive File Access', name: 'linux-sensitive-file-access'}
      ]
    }
  },
  beforeMount() {
    if (performance.navigation.type === 1) {
      this.$router.push({name: this.$router.currentRoute.name, query: this.$router.currentRoute.query})
      this.selectedInsight = this.$route.path.split('/').reverse()[0]
    } else {
      this.$router.push({name: this.$router.currentRoute.name, query: this.$router.currentRoute.query})
    }
  },
  methods: {
    changeInsightView(key, path) {
      switch (key) {
        case 'windows-dns-requests':
          this.routePath = '/insights/windows-dns-requests'
          break
        case 'windows-logon-failures':
          this.routePath = '/insights/windows-logon-failures'
          break
        case 'windows-external-connections':
          this.routePath = '/insights/windows-external-connections'
          break
        case 'windows-privileged-executions':
          this.routePath = '/insights/windows-privileged-executions'
          break
        case 'linux-process-launching-shells':
          this.routePath = '/insights/linux-process-launching-shells'
          break
        case 'linux-privileged-executions':
          this.routePath = '/insights/linux-privileged-executions'
          break
        case 'linux-external-connections':
          this.routePath = '/insights/linux-external-connections'
          break
        case 'linux-login-failures':
          this.routePath = '/insights/linux-login-failures'
          break
        case 'linux-sensitive-file-access':
          this.routePath = '/insights/linux-sensitive-file-access'
          break
        default:
          return
      }
      this.$router.push(this.routePath)
    }
  },
  computed: {
    ...mapGetters(['agentEnvironment', 'insightsDateRangeUserSetting']),
    isStatsLoading() {
      return false
    }
  },
  components: {
    PageHeaders,
    DateRangeDropdown
  }
}
</script>

<style scoped>
@import 'assets/styles/_variables.css';
@import 'assets/styles/text.css';
@import 'assets/styles/icon.css';

.insights-content {
  overflow: hidden;
  height: calc(100% - 45px);
}

.table-data {
  >>> .el-tabs__header {
    margin: 0;
  }
}

.el-tabs__content {
  height: 100%;

  .el-tab-pane {
    height: 100%;
    overflow-y: scroll;
  }
}

.el-menu {
  border-right: 0px;
  padding-right: 10px;
}

.el-menu-item {
  height: 100%;
  width: 100%;
  min-width: unset;
  white-space: normal;
  word-wrap: break-word;
  line-height: 30px;
  padding-left: 12px !important;
  padding-right: 0px !important;

  &.is-active {
    color: #409eff;
  }
}

>>> .el-submenu__title {
  padding: 0px !important;
  height: 40px;
  line-height: 40px;
}

>>> .el-submenu__icon-arrow {
  right: 2px;
}

.c-stats_row {
  height: 300px;
  margin-bottom: 20px;
}

.c-stats_row_table {
  height: calc(100% - 300px);
}

.c-stats_row_datesel {
  .el-tag {
    margin: 0px 10px 0px 0px;
    vertical-align: sub;

    &.active {
      color: #409eff;
      border: 1px solid #d9ecff;
      background-color: #ecf5ff;
    }
  }
}

.c-stats_row_timeseries {
  height: 100%;
}

.c-stats_row_title {
  height: 24px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/insights/Insights.vue